module.exports = __webpack_public_path__ + "static/media/learnMore.43c3c424.mp3";